export const COOKIE_NAME = 'ab-optimize';
export const ONE_DAY_IN_SECONDS = 60 * 60 * 24; // 86400
export const THREE_MONTHS_IN_SECONDS = 60 * 60 * 24 * 90; // 7776000
export const CONTROL_COOKIE = 1;
export const AB_COOKIE = {
  LEGACY: CONTROL_COOKIE,
  KEYCLOAK: 2,
} as const;
